module.exports = __webpack_public_path__ + "images/service_list_table/icon_ranking_gold_3a5c631aae480e7b710dec7469010604.png";